// robust email validator
export function emailIsValid(email) {
    return !!email.match(/^[A-Za-z0-9](([.\-_]{1})?([A-Za-z0-9]+))+@[A-Za-z0-9-]+\.[A-Za-z]{2,}((\.)?[A-Za-z]+)?$/);
}
